export function isString(value) {
    return typeof value === 'string';
}
export function isNumber(value) {
    return typeof value === 'number';
}
export function isFunction(value) {
    return typeof value === 'function';
}
export function pixelOrPercentage(value) {
    if (!value)
        return '';
    if (isString(value)) {
        return "".concat(String(value).replace('%', ''), "%");
    }
    return "".concat(value, "px");
}
export function objectIsEmpty(obj) {
    for (var prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
        }
    }
    return JSON.stringify(obj) === JSON.stringify({});
}
